import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const MODES = [["telephone", "Téléphone"], ["visio", "Visioconférence"], ["bureau", "Au bureau d'Aix"]];
export const SLOTS = [["matin", "Matin"], ["apres-midi", "Après-midi"], ["indifferent", "Indifférent"]];
export const REVENUES = ["< 500 K€", "500 K€ – 1 M€", "1 – 5 M€", "5 – 10 M€", "> 10 M€"];
export const EMPLOYEES = ["0 – 5", "6 – 19", "20 – 49", "50 – 249", "250 +"];
export const TIMINGS = ["Dès que possible", "6 à 12 mois", "1 à 2 ans", "Plus de 2 ans", "Je me renseigne"];

export const Chips = ({ name, options, value, onChange }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => {
      const [val, label] = Array.isArray(o) ? o : [o, o];
      const active = value === val;
      return (
        <button type="button" key={val} data-testid={`rdv-${name}-${val}`} onClick={() => onChange(active && name !== "meeting_mode" && name !== "preferred_slot" ? "" : val)}
          className={`px-4 py-2 text-sm border rounded-full transition-colors ${active ? "bg-[#1B2A4A] text-white border-[#1B2A4A]" : "border-gray-300 text-[#475569] hover:border-[#1B2A4A]"}`}>
          {label}
        </button>
      );
    })}
  </div>
);

export const ReqLabel = ({ text }) => (typeof text === "string" && /\s*\*$/.test(text)
  ? <>{text.replace(/\s*\*$/, "")}<span className="text-red-500 ml-0.5" aria-hidden="true">*</span></>
  : text);

export const Field = ({ id, label, value, onChange, error, ...props }) => (
  <div>
    <Label htmlFor={`rdv-${id}`} className="text-xs uppercase tracking-wider text-[#475569]"><ReqLabel text={label} /></Label>
    <Input id={`rdv-${id}`} data-testid={`rdv-${id}`} value={value} onChange={(e) => onChange(e.target.value)} step={props.type === "number" ? "any" : undefined} aria-invalid={!!error} className={`rounded-none mt-1.5 h-11 ${error ? "border-red-500 ring-1 ring-red-500" : "border-gray-300"}`} {...props} />
    {error && <p data-testid={`rdv-${id}-error`} className="text-xs text-red-600 mt-1">{error}</p>}
  </div>
);

export const SelectField = ({ id, label, value, onChange, options, placeholder }) => (
  <div>
    <Label className="text-xs uppercase tracking-wider text-[#475569]"><ReqLabel text={label} /></Label>
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger data-testid={`rdv-${id}`} className="rounded-none mt-1.5 border-gray-300 h-11"><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent className="max-h-72">{options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
    </Select>
  </div>
);

export const Group = ({ step, title, children }) => (
  <fieldset className="space-y-5">
    <legend className="flex items-center gap-3 mb-5">
      <span className="w-8 h-8 rounded-full bg-[#E0C173] text-[#1B2A4A] font-semibold text-sm flex items-center justify-center">{step}</span>
      <span className="font-display text-lg font-semibold text-[#1B2A4A]">{title}</span>
    </legend>
    {children}
  </fieldset>
);

export const ChipField = ({ label, children }) => (
  <div>
    <div className="text-xs uppercase tracking-wider text-[#475569] mb-2">{label}</div>
    {children}
  </div>
);
